import { Router } from 'vue-router';

class NavigationService {
  private router: Router | null = null;

  setRouter(router: Router) {
    this.router = router;
  }

  push(to: Parameters<Router['push']>[0]) {
    if (this.router) {
      return this.router.push(to);
    }
    throw new Error('Router not initialized in NavigationService');
  }

  replace(to: Parameters<Router['replace']>[0]) {
    if (this.router) {
      return this.router.replace(to);
    }
    throw new Error('Router not initialized in NavigationService');
  }

  go(delta: number) {
    if (this.router) {
      return this.router.go(delta);
    }
    throw new Error('Router not initialized in NavigationService');
  }

  back() {
    if (this.router) {
      return this.router.back();
    }
    throw new Error('Router not initialized in NavigationService');
  }
}

const navigationService = new NavigationService();
export default navigationService;
